import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getHeatMapAreas } from "../api/heat-map.api";
import type { AreaModel } from "../types/Area";
import type { DashboardFilterPayload } from "../utils/heat-map.utils";

export const useHeatMapAreas = (payload: DashboardFilterPayload) => {
  const [data, setData] = useState<AreaModel[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run: runLatestRequest, loading } = useLatestRequest();

  const fetchData = useCallback(async () => {
    try {
      setError(null);
      const result = await runLatestRequest((signal) => getHeatMapAreas(payload, signal));

      if (!result) return undefined;

      setData(result);
      return result;
    } catch (fetchError) {
      setData(null);
      setError(getApiErrorMessage(fetchError, "Failed to load heat map"));
      return undefined;
    }
  }, [payload, runLatestRequest]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
